module.exports = __webpack_public_path__ + "static/offers.en-37034de7ebd2b689b537c5f8f8e998c5.png";